/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
==========================================================================================*/
import axios from '@/axios.js'
export default {


  fetchPartnersData ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${axios.defaults.baseURL  }/partners`)
        .then((response) => {
          commit('SET_PARTNERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })

  },

  fetchTaxesData ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${axios.defaults.baseURL  }/taxes`)
        .then((response) => {
          commit('SET_TAXES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })

  },
  fetchGroupPaymentStatisticsData (context, payload) {
    const token = localStorage.getItem('access_token')
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    return new Promise((resolve, reject) => {
      axios.post(`${axios.defaults.baseURL  }/group-payment-statistics`, payload)
        .then((response) => {
          context.commit('SET_GROUP_PAYMENTS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })

  },

  fetchRegionMunicipalitiesData ({ commit }, region_id) {
    return new Promise((resolve, reject) => {
      axios.get(`${axios.defaults.baseURL  }/municipalities/${region_id}`)
        .then((response) => {
          commit('SET_REGION_MUNICIPALITIES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })

  },


  fetchDetailPaymentStatisticsData (context, payload) {
    const token = localStorage.getItem('access_token')
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    return new Promise((resolve, reject) => {
      axios.post(`${axios.defaults.baseURL  }/group-status`, payload)
        .then((response) => {
          context.commit('SET_DETAIL_PAYMENTS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })

  },
  fetchTerminalPaymentStatisticsData (context, payload) {
    const token = localStorage.getItem('access_token')
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    return new Promise((resolve, reject) => {
      axios.post(`${axios.defaults.baseURL  }/terminal-payment-statistics`, payload)
        .then((response) => {
          context.commit('SET_TERMINAL_PAYMENTS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  fetchInvoice (context, payload) {
    const token = localStorage.getItem('access_token')
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    return new Promise((resolve, reject) => {
      axios.post(`${axios.defaults.baseURL  }/invoice`, payload)
        .then((response) => {
          context.commit('SET_INVOICE', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })

  }


}
